import React, { useEffect, useState } from "react";
import {Result} from "antd";
import HeaderComponent from "../component/header";
import { useSearchParams } from "react-router-dom";
import { api_verifyemail } from "../api/verify";

const VerifyEmailPage: React.FC = () => {
  
    const [searchParams] = useSearchParams();

    const token = searchParams.get("token");

    useEffect(() => {
        if (token === null)
        {
            return
        }
        console.log(token)
        // api_verifyemail(token)
        // .then((res) => {
        //     if (res.bSuccess)
        //     {
        //         message.success(res.msg)
        //         navigate("/verifyemail");
        //     }
        //     else{
        //         message.error('Wrong Input! Please call our office')
        //     }
        // })
        // .catch((error) => {
        // console.error("An error occurred:", error.message);
        // return
        // });
    }, [token]);
    
    return (
        <div>
            <HeaderComponent />
            <div className="flex justify-center items-center body-height text-style">
                <Result
                    status="success"
                    title="Verification Email Sent"
                    subTitle="We've sent a verification email to your email address. Please check your inbox and click the verification link to continue."
                    // extra={[
                    //     <Button type="primary" key="home">
                    //     Back to Home
                    //     </Button>,
                    //     <Button key="resend">
                    //     Resend Email
                    //     </Button>,
                    // ]}
                />
            </div>
        </div>
    );
};

export default VerifyEmailPage;